import { Tooltip } from '@mui/material';

import Typography from '@classify/react-core-components/Typography';
import { useIsOverflowed } from '../../../utils';

export default function MenuItemName({ name }) {
  const { isOverflowed, setDomElement } = useIsOverflowed([name]);

  return (
    <Tooltip title={isOverflowed ? name : ''} enterDelay={500}>
      <Typography variant="body" noWrap ref={setDomElement}>
        {name}
      </Typography>
    </Tooltip>
  );
}
